<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" :src="Core.Session.Setting.getSetting('environment.ui.logoFull')" :width="Core.Session.Setting.getSetting('environment.ui.logoFullWidth')">
        <img class="navbar-brand-minimized" :src="Core.Session.Setting.getSetting('environment.ui.logoMinimized')" width="30">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none pull-right">
        <b-nav-item v-if="Core.Session.AuthUser.can('order_management_post')" class="px-3" :to="Core.Definition.getDefinition('/commerce/achats')"><i class="fa fa-shopping-cart mr-2"></i>{{Core.Definition.getDefinition('Achats')}}</b-nav-item>
        <b-nav-item v-if="Core.Session.AuthUser.can('event_booking_management_post_book')" class="px-3" :to="Core.Definition.getDefinition('/evenement/nouvelles-reservations')"><i class="cui-user-follow mr-2"></i>{{Core.Definition.getDefinition('Nouvelles réservations')}}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="">
          <HeaderDropdownAccount/>
        </b-nav-item>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav v-if="navItems.length > 0" ref="sidebarNav" :_navItems="navItems"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid mb-3">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="ml-auto">
        <a href="https://perfoplanning.com">{{Core.Definition.getDefinition('Propulsé par Perfoplanning')}}</a>
        <span class="ml-1">&copy; {{Core.Session.Setting.getSetting('copyrightYear')}} {{Core.Session.Setting.getSetting('version')}}</span>
      </div>
    </TheFooter>

  </div>
</template>

<script>

import nav from '../_nav'
import { Header as AppHeader, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import HeaderDropdownAccount from '../../containers/HeaderDropdownAccount'
import AppSidebar from '../../components/Sidebar/Sidebar'
import SidebarFooter from '../../components/Sidebar/SidebarFooter'
import SidebarForm from '../../components/Sidebar/SidebarForm'
import SidebarHeader from '../../components/Sidebar/SidebarHeader'
import SidebarMinimizer from '../../components/Sidebar/SidebarMinimizer'
import SidebarNav from '../../components/Sidebar/SidebarNav'
import SidebarToggler from '../../components/Sidebar/SidebarToggler'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    HeaderDropdownAccount,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      navItems: nav.getNav(),
      Core: window.Core
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      let list = this.$route.matched.filter((route) => route.name || route.meta.label )
      let branchName = Core.Session.branch.name
      if (!Core.Validation.isEmpty(branchName)) {
        list.unshift({
          name: branchName
        })
      }
      return list
    }
  }
}
</script>



